interface LogoProps {
  height?: number;
  width?: number;
}

export const Logo = ({ height = 40, width = 40 }: LogoProps) => (
  <img
    loading="eager"
    src="/icon.png"
    alt="Logo - Pro Leilão"
    height={height}
    width={width}
  />
);
